
















































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {store} from "@/_store";
import {SNACK_ACTION} from "@/_store/snackbar";
import {IMediaViewModel} from "@/_objects/IMedia";
import Confirm from "@/components/Confirm.vue";
import {updateApproveWithComments} from "@/_services/media.services";

@Component({
    components: {Confirm},
})
export default class MediaApprove extends Vue {
    @Prop() private media!: IMediaViewModel;
    @Prop({default: false}) private show!: string;
    private loading: boolean = false;
    private dialogActiveShow: boolean = false;
    private dialogActiveMsg: string = "";

    get isApproveMode() {
        return !this.media.isApproved;
    }

    private close() {
        this.$emit('update:show', false);
    }

    private confirm() {
        this.dialogActiveShow = true;
        if (!this.isApproveMode) {
            this.dialogActiveMsg = "Are you sure you want to Unapprove this creative?";
        } else {
            this.dialogActiveMsg = "Are you sure you want to Approve this creative?";
        }
    }

    private async onConfirmSave() {
        this.loading = true;
        if (!this.isApproveMode) {
            try {
                const newUser = await updateApproveWithComments(this.media.id, false, this.media.comment);
                if (newUser) {
                    store.dispatch(SNACK_ACTION.WARNING, `<b>Creative from ${this.media.publisher} has been Unapproved.`);
                    this.$emit('update:show', false);
                    this.$emit('success', true);
                }
            } catch (err) {
                // Do nothing
            }
        } else {
            try {
                const newUser = await updateApproveWithComments(this.media.id, true, this.media.comment);
                if (newUser) {
                    store.dispatch(SNACK_ACTION.SUCCESS, `<b>Creative from ${this.media.publisher} has been Approved.`);
                    this.$emit('update:show', false);
                    this.$emit('success', true);
                }
            } catch (err) {
                // Do nothing
            }
        }
        this.loading = false;

    }

    @Watch('media')
    private onMediaChanged() {
        (this.$refs.form as any).resetValidation();
    }

}
